'use strict';

import uiRouter from '@uirouter/angularjs';

export default angular
  .module('emilSettings', [
    uiRouter
  ])
  .config(['$stateProvider', function ($stateProvider) {
    $stateProvider
    .state('main.settings', {
      abstract: true,
      url: 'verwaltung',
      template: '<h2>Verwaltung</h2><ui-view/>',
      data: {
        displayName: 'Verwaltung'
      }
    })
    .state('main.settings.profile', {
      url: '/profil',
      component: 'settingsProfile',
      params: {
        permission: '11111'
      },
      data: {
        displayName: 'Profil'
      }
    })
    .state('main.settings.news', {
      url: '/neuigkeiten',
      component: 'settingsNews',
      params: {
        permission: '10000'
      },
      data: {
        displayName: 'Neuigkeiten'
      }
    })
    .state('main.settings.news-add', {
      url: '/neuigkeiten',
      component: 'formNews',
      params: {
        item: undefined,
        permission: '10000'
      },
      data: {
        displayName: 'Neuigkeit hinzufügen'
      }
    })
    .state('main.settings.user', {
      url: '/nutzer',
      component: 'settingsUsers',
      params: {
        permission: '10000'
      },
      data: {
        displayName: 'Nutzer'
      }
    })
    .state('main.settings.user-add', {
      url: '/nutzer',
      controller: 'UserCtrl',
      template: require('./components/form-users/user-form.html'),
      params: {
        permission: '10000'
      },
      data: {
        displayName: 'Nutzer hinzufügen'
      }
    })
    .state('main.settings.user-edit', {
      url: '/nutzer',
      controller: 'UserCtrl',
      template: require('./components/form-users/user-form-edit.html'),
      params: {
        item: undefined,
        permission: '10000'
      },
      data: {
        displayName: 'Nutzer bearbeiten'
      }
    })
    .state('main.settings.center', {
      url: '/zentren',
      component: 'settingsCenter',
      params: {
        permission: '10000'
      },
      data: {
        displayName: 'Zentren'
      }
    })
    .state('main.settings.center-add', {
      url: '/zentren',
      component: 'formCenter',
      params: {
        item: undefined,
        permission: '10000'
      },
      data: {
        displayName: 'Zentren hinzufügen'
      }
    })
    .state('main.settings.protocol', {
      url: '/protokoll',
      component: 'protocol',
      params: {
        permission: '10000'
      },
      data: {
        displayName: 'Protokoll'
      }
    })
    .state('main.settings.network', {
      url: '/verbunde',
      component: 'settingsNetwork',
      params: {
        permission: '10000'
      },
      data: {
        displayName: 'Zentrumsverbund'
      }
    })
    .state('main.settings.network-add', {
      url: '/verbunde/neu',
      component: 'formNetwork',
      params: {
        item: undefined,
        permission: '10000'
      },
      data: {
        displayName: 'Zentrumsverbund erstellen'
      }
    })
    .state('main.settings.options', {
      url: '/optionen',
      displayName: 'Optionen',
      component: 'settings',
      params: {
        permission: '10000'
      },
      data: {
        displayName: 'Optionen'
      }
    })
    .state('main.settings.deletionrequests', {
      url: '/loeschantraege',
      component: 'deletionRequests',
      params: {
        permission: '11111'
      },
      data: {
        displayName: 'Löschanträge'
      }
    })
    .state('main.settings.export', {
      url: '/export',
      component: 'settingsExport',
      params: {
        permission: '01101'
      },
      data: {
        displayName: 'Export'
      }
    });
  }])
  .component('deletionRequests', require('./components/deletionrequests/deletionrequests.component'))
  .component('formCenter', require('./components/form-center/form-center.component'))
  .component('formNetwork', require('./components/form-network/form-network.component'))
  .component('formNews', require('./components/form-news/form-news.component'))
  .component('protocol', require('./components/protocol/protocol.component'))
  .component('settings', require('./components/settings/settings.component'))
  .component('settingsCenter', require('./components/settings-center/settings-center.component'))
  .component('settingsNetwork', require('./components/settings-network/settings-network.component'))
  .component('settingsNews', require('./components/settings-news/settings-news.component'))
  .component('settingsProfile', require('./components/settings-profile/profile.component'))
  .component('settingsUsers', require('./components/settings-users/settings-users.component'))
  .component('settingsExport', require('./components/export/export.component'))
  .controller('UserCtrl', require('./components/form-users/user'))
;



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/settings/settings.module.js